// extracted by mini-css-extract-plugin
module.exports = {"textLink":"TextLink_textLink__3bylf","bold":"TextLink_bold__1IuSo"};